import { isIpad } from "@utils/design-tokens";
import { DEVICE_SIZE } from "@utils/index";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";
import { useMediaQuery } from "react-responsive";

const useDeviceType = () => {
  const { width } = DEVICE_SIZE;
  const { isFold } = useIsFoldable();
  const mobileQuery = useMediaQuery({ maxWidth: 767 });
  const tabletQuery = useMediaQuery({ minWidth: 767, maxWidth: 1279 });
  const desktopQuery = useMediaQuery({ minWidth: 1279 });
  const isMobile = isFold || mobileQuery || width < 767;
  const isTablet =
    !isFold && (tabletQuery || (width > 767 && width <= 1279) || isIpad());
  const isDesktop = !isFold && (desktopQuery || width > 1279 || !isIpad());
  const isLargeScreen = isDesktop && !isTablet && !isMobile;
  return { isMobile, isTablet, isDesktop, isLargeScreen, isFold };
};

export default useDeviceType;
